export const CASHDESK_NOTE_MAX_LENGTH = 255;
export const CASHDESK_NAME_MIN_LENGTH = 3;
export const CASHDESK_NAME_MAX_LENGTH = 50;
export const CASHDESK_FAST_DEPOSITS_MAX_LENGTH = 5;
